export default __webpack_public_path__ + "static/media/pattern-background.94ce5a4a.png";